// extracted by mini-css-extract-plugin
export default {"container":"ConfirmNominationModal_container__MS2D4","warning-icon":"ConfirmNominationModal_warning-icon__rlcsh","title":"ConfirmNominationModal_title__JHVZ6"};